<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">{{$t("pages")}} </h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">

        <div class="row">
         <div class="col-sm-3">
            <fg-input>
              <el-select v-model="contentTypeName" filterable clearable :placeholder="$t('content_page')">
                <el-option
                  class="select-default"
                  v-for="item in contentTypeOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-sm-3">
              <fg-input>
                <el-select @change="filterByNgoCountry" v-model="ngoID" filterable clearable :placeholder="$t('filter_by_ngo')">
                    <el-option
                    class="select-default"
                    v-for="ngo in NGO"
                    :key="ngo.id"
                    :label="ngo.name"
                    :value="ngo.id"></el-option>
                </el-select>
              </fg-input>
          </div>
          <div class="col-sm-3">
            <fg-input>
              <el-select @change="filterByNgoCountry" v-model="locationID" filterable clearable :placeholder="$t('filter_by_country')">
                   <el-option
                   class="select-default"
                   v-for="country in Countries"
                   :key="country.id"
                   :label="country.name"
                   :value="country.id"></el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-sm-3">
            <fg-input>
                <p-button class="btn btn-primary btn-block" @click="handleCreateModal">
                  <i class="fa fa-plus"></i> {{ $t('new_page') }}
                </p-button>
            </fg-input>
          </div>
        </div>
      </div>
      <div class="card-body">

        <div class="row">
          <div class="col-sm-6">
              <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input
                class="input-sm"
                :placeholder="$t('search')"
                v-model="searchQuery"
                addon-right-icon="nc-icon nc-zoom-split"
              ></fg-input>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <el-table v-loading="loading" :element-loading-text="$t('loading_data') + '...'" class="table-striped"
            :data="paginated" border style="width: 100%">

            <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" sortable></el-table-column>

             <el-table-column :min-width="120" fixed="right" class-name="td-actions text-center" :label="$t('page_link')">
              <template slot-scope="props">
                <div class="page-link" @click="copyLink( mobileRoute[props.row.post.id] )">
                  <span class="page-link__link">{{ mobileRoute[props.row.post.id] ? mobileRoute[props.row.post.id] : ''}}</span>
                  <i class="fa fa-copy"></i>
                </div>
                <span class="page-link__copy">{{ $t('copy_this_link_to_clipboard') }}</span>
              </template>
            </el-table-column>

            <el-table-column :min-width="120" fixed="right" class-name="td-actions text-center" :label="$t('actions')">
              <template slot-scope="props">
                <p-button type="primary" size="sm" icon @click="handleView(props.$index, props.row)">
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button type="danger" size="sm" icon @click="handleDelete(props.$index, props.row)">
                  <i class="fa fa-trash"></i>
                </p-button>
              </template>
            </el-table-column>

          </el-table>
        </div>

      </div>

      <div class="card-footer">
        <paginate :pagination="pagination" :metadata="metaData" :allData="getPages"></paginate>
      </div>


    </div>

    <!-- Edit Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{ $t('choose_page_template') }}</h4>
      <form>
        <fg-input :label="$t('select_page_template')">
          <el-select size="large" class="select-primary" filterable clearable v-model="form.pageTemplateID" :placeholder="$t('select_page_template')">
            <el-option
              class="select-primary"
              v-for="pageTemplate in pageTemplates"
              :key="pageTemplate.id"
              :label="pageTemplate.title"
              :value="pageTemplate.id"
            ></el-option>
          </el-select>
        </fg-input>

        <fg-input :label="$t('select_language')">
            <el-select size="large" class="select-primary" filterable clearable v-model="form.language_ID" :placeholder="$t('select_language')">
              <el-option
                class="select-primary"
                v-for="lang in Languages"
                :key="lang.id"
                :label="lang.name"
                :value="lang.id"
              ></el-option>
            </el-select>
          </fg-input>

          <fg-input :label="$t('select_default_ngo')">
              <el-select size="large" class="select-primary" v-model="form.ngo_ID" filterable clearable :placeholder="$t('select_default_ngo')">
                   <el-option
                   class="select-primary"
                   v-for="ngo in NGO"
                   :key="ngo.id"
                   :label="ngo.name"
                   :value="ngo.id"></el-option>
              </el-select>
          </fg-input>

          <fg-input :label="$t('select_default_country')">
              <el-select size="large" class="select-primary" v-model="form.location_ID" filterable clearable :placeholder="$t('select_default_country')">
                   <el-option
                   class="select-primary"
                   v-for="country in Countries"
                   :key="country.id"
                   :label="country.name"
                   :value="country.id"></el-option>
              </el-select>
          </fg-input>

          <fg-input :label="$t('select_ngos_and_countries')">
            <el-select size="large" class="select-primary" multiple filterable clearable v-model="form.categories" :placeholder="$t('select_ngos_and_countries')">
              <el-button @click="checkAllContent" style="width:100%; border:none">{{ $t('select_all') }}</el-button>
                <el-option-group
                  v-for="group in allCategories"
                  :key="group.id"
                  :label="group.name">
                  <el-option
                    v-for="item in group.children"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-option-group>
            </el-select>
          </fg-input>

      </form>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal"
            >{{$t('cancel')}}</p-button
          >
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="primary" link @click="createPage">{{$t('continue')}}</p-button>
        </div>
      </template>
    </modal>

  </div>
</template>
<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Sidebar from "src/sidebarLinks.js";

import { Message, Form } from "element-ui";
import Modal from "src/components/UIComponents/Modal.vue";

import Resource from "@/util/Api/resource.js";
import { fetchPageTemplates } from "@/util/Api/pageTemplate.js";
import { fetchPages, deletePages } from "@/util/Api/page.js";
import { values } from 'd3';
import Con from "@/util/helpers.js";
import Paginate from '../../../UIComponents/Paginate.vue';

const PageResource = new Resource("post/content/Page");
const CategoryResource = new Resource("category");

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  components: {
    PPagination,
    Modal,
    Paginate
  },
  watch:{
    contentTypeName: function(val){
      this.contentTypeObject.forEach(type => {
        if(type.label === val){
          this.contentType = type.value;
          this.filterDataCategory();
        }
      });
    },
  },

  data() {
    return {
      modals: {
        classic: false
      },
      pagination: {
        perPage: 10,
        perPageOptions: [10, 20, 30, 60, 500, 1000],
        currentPage:1,
        nextPage:'',
        prevPage:'',
        total:'',
        from:'',
        to:'',
        page:'',
      },
      contentTypeName: this.$t("content_page_editor"),
      locationID: "",
      ngoID:"",
      contentType: Number,
      contentTypeObject: [
        {
          label: this.$t("content_page_editor"),
          value: 'content'
        },
        {
          label: this.$t("grid_page"),
          value: 'grid'
        }
      ],
      contentTypeOptions:[
        this.$t("content_page_editor"),
        this.$t("grid_page"),
      ],
      pageOptions:[],
      allPagePost:[],
      searchQuery: "",

      propsToSearch: ["post.title"],

      tableColumns: [
        {
          prop: "post.id",
          label: this.$t("id"),
          minWidth: 40
        },
        {
          prop: "post.postTitle",
          label: this.$t("page_title"),
          minWith: 300
        },
        {
          prop: "post.ngoName.name",
          label: this.$t("ngo")
        },
        {
          prop: "post.language_Name.name",
          label: this.$t("language")
        }
      ],
      tableData: [],
      metaData: {
        meta:'',
        links:''
      },
      loading: false,
      pageTemplates: [],
      form: [],
      mobileRoute:[],
      NGO:[],
      Countries:[],
      Languages:[],
      allCategories:[],
    };
  },

  computed: {

    queriedData() {
       let result = this.tableData;
       if (this.searchQuery) {
            result = result.filter((row) => {
                return row.post.title.toLowerCase().includes(this.searchQuery.toLowerCase());
            });
        }
        return result;
    },

    paginated(){
        return Con.paginateData(this.queriedData, this.pagination);
    },

  },

  created() {
    this.contentType = this.contentTypeObject[0].value;
    this.getPageTemplates();
    this.getPages();
    this.getCategories();
  },
  methods: {

    copyLink( link ) {
      navigator.clipboard.writeText(link);
      this.showAlertMessage(this.$t("copied_the_link")+ ": " + link, "success");
    },

    handleCreateModal() {
      this.modals.classic = true;
    },

    handleCloseModal() {
      this.modals.classic = false;
    },

    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },

    // Handle delete
    handleDelete(index, row) {
      this.loading = true;
      this.$confirm(this.$t("are_you_sure_you_want_to_delete_this_page"),
      this.$t("warning"), {
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "btn-danger",
        confirmButtonClass: "btn-primary",
        type: "warning"
      })
        .then(() => {
          deletePages(row.post.id)
            .then(response => {
              this.loading = false;
              this.showAlertMessage(this.$t("page_deleted_successfully"), "success");
              this.getPages();
            })
            .catch(error => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // Handle view
    handleView(index, row) {
      this.$router.push({
        name: "PageContentEdit",
        params: { post: row, pageOptions: this.pageOptions }
      });
    },

    // Filter based on content type
    filterDataCategory() {
        let filteredData = [];
        this.tableData = [];

        this.allPagePost.forEach(post => {
            post.post.postTitle = post.post.title.split('___')[0];
            if(post.post.postTitle.includes('|')) {
               post.post.postTitle = post.post.postTitle.split('|')[1];
            }

            if(post.post.postTemplateName.toLowerCase().includes(this.contentType)){
               filteredData.push(post);
            }
        });

        filteredData.forEach(post => {
            if(post.post.postTemplateName.toLowerCase().includes('content')) {
              this.$set(this.mobileRoute, post.post.id, "/#/contentPage/" + post.post.id);
            } else if( post.post.postTemplateName.toLowerCase().includes('grid') ){
              this.$set(this.mobileRoute, post.post.id, "/#/listGrid/" + post.post.id);
            }
            if(!post.post.title.includes('|')) {
               post.post.title = post.post.id + "  |  " + post.post.title.split('___')[0];
            }
        });
        this.tableData = filteredData;
    },

    // Filter by NGO or Country
    filterByNgoCountry() {
       this.tableData = [];
       let filterData = [];

      this.allPagePost.forEach((post) => {
         if(post.post.categories.length > 0) {
          if(this.ngoID !== "" || this.locationID !== "") {
            post.post.categories.filter((category) => {
              if(category.id === this.ngoID) {
                filterData.push(post);
              } else if(category.id === this.locationID) {
                filterData.push(post);
              }
            });
          }
         }
      });

       // return unique data
      const filteredData = filterData.map(
          (obj) => { return obj }
        ).filter(
          (item, index, arr) => {
            return arr.indexOf(item) == index
          }
      );

      filteredData.forEach(post => {
            post.post.postTitle = post.post.title.split('___')[0];
            if(post.post.postTitle.includes('|')) {
               post.post.postTitle = post.post.postTitle.split('|')[1];
            }
            if(post.post.postTemplateName.toLowerCase().includes('content')) {
              this.$set(this.mobileRoute, post.post.id, "/#/contentPage/" + post.post.id);
            } else if( post.post.postTemplateName.toLowerCase().includes('grid') ){
              this.$set(this.mobileRoute, post.post.id, "/#/listGrid/" + post.post.id);
            }
            if(!post.post.title.includes('|')) {
               post.post.title = post.post.id + "  |  " + post.post.title.split('___')[0];
            }
      });

      this.tableData = filteredData;
    },

    // Get all page post with pagination
    async getPages(page_url) {
      this.loading = true;
      if(page_url) {
         page_url = Con.splitStringLinks(page_url);
      }
      await PageResource.list(page_url)
      .then(response => {
          let pageOptionsTemp = [];
          let filteredData = [];

          response.data.data.forEach(post => {
            post.post.mainPostTitle = post.post.title;
            if(post.post.title.split('--').length > 1) {
               post.post.title = post.post.title.split("--")[1];
            }

            pageOptionsTemp.push({
                title: post.post.title,
                id: post.post.id
            });
            filteredData.push(post);
          });

          if(this.allPagePost.length > 0){
             this.allPagePost = [...filteredData, ...this.allPagePost];
             this.pageOptions = [...pageOptionsTemp, ...this.pageOptions];
          } else {
             this.allPagePost = filteredData;
             this.pageOptions = pageOptionsTemp;
          }

          this.metaData.meta = response.data.meta;
          this.metaData.links = response.data.links;
          this.filterDataCategory();
          this.loading = false;
        }).catch(error => {
           console.log('error', error);
           this.loading = false;
        });
    },

    // Get all pag template
    async getPageTemplates() {
      await fetchPageTemplates()
        .then(response => {
          this.pageTemplates = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    // Get all NGOs in a categories
    async getCategories() {
      await CategoryResource.list({})
      .then(response => {
        let categories = response.data;
        categories.forEach(element => {
          if(element.name.toLowerCase().includes("ngos")) {
             this.NGO = element.children;
             this.allCategories.push(element);
          } else if(element.name.toLowerCase().includes("countries")) {
             this.Countries = element.children;
             this.allCategories.push(element);
          } else if (element.name.toLowerCase().includes("languages")) {
             this.Languages = element.children;
          }
        });
      }).catch(error => {
        console.log('error', error)
      });
    },

    // Check All
    checkAllContent() {
       if(this.form.categories.length === 0) {
          this.allCategories.forEach(element => {
              element.children.forEach(item => {
                this.form.categories.push(item.id);
              });
          });
       } else {
         this.form.categories = [];
       }
    },

    // Creating page function
    createPage() {
      this.modals.classic = false;
      this.$router.push({
        name: "PageContent",
        params: { id: this.form.pageTemplateID, formDetails: this.form }
      });
    }
  }
};
</script>
<style lang="scss">
.page-link{
    display: inline-block;
    float: left;
    position: relative;
    padding: 10px 20px;
    background-color: #dcdcdc;
    color: #51cbce;
    border-radius: 5px;
    &__link{
      padding-right: 20px;
    }
    +.page-link__copy{
      opacity: 0;
      height: 0;
      transition: opacity .25s ease-in-out;
      position: absolute;
      left: 18px;
      top: -5px;
      z-index: 2;
    }

    &:hover{
      +.page-link__copy {
        opacity: 1;
        height: auto;
      }
    }
}
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
a.custom-link {
  background-color: #2c2c2c;
  padding: 20px;
  color: white;
  text-transform: uppercase;
  font-weight: 700;
}
a.custom-link:hover {
  background-color: #6bd098;
  color: white;
}
</style>
